import React, { useEffect, useRef } from 'react';
import { ParallaxLayer } from 'react-spring/renderprops-addons';
import './AFullService.scss';
import anime from 'animejs';
import throttle from '../throttle';
import CylinderScroll from './CylinderScroll';
import scrollMouse from '../../home/assets/v4/scroll.svg';
import useOnScreen from '../useOnScreen';

const AFullService = (props) => {
  const {
    pOffset, layoutFactor = 1, offsetAdjust = 0,
  } = props;
  const ref = useRef();
  const titleRef = useRef(null);
  const subtitleRef = useRef(null);

  let isIn = true;

  const onScreen = useOnScreen(ref, '0px', 0.5); // 推荐 rootMargin 用 0px

  // 打字机效果
  useEffect(() => {
    if (titleRef.current) {
      // 柔和的开场动画
      anime({
        targets: titleRef.current,
        scale: [
          { value: 0.7, duration: 0 },
          { value: 1.2, duration: 500, easing: 'easeOutCubic' },
          { value: 0.98, duration: 300, easing: 'easeOutBack' }
        ],
        rotate: [
          { value: -10, duration: 0 },
          { value: 6, duration: 400, easing: 'easeOutExpo' },
          { value: 0, duration: 300, easing: 'easeOutBack' }
        ],
        translateY: [
          { value: -50, duration: 0 },
          { value: 0, duration: 800, easing: 'easeOutExpo' }
        ],
        opacity: [
          { value: 0, duration: 0 },
          { value: 1, duration: 600, easing: 'linear' }
        ],
        duration: 1000,
        easing: 'easeOutExpo',
        update: function (anim) {
          const el = titleRef.current;
          if (el) {
            const progress = anim.progress / 100;
            el.style.textShadow = `0 0 ${10 + 20 * progress}px #FA3633, 0 0 ${5 + 10 * progress}px #3A74E0`;
          }
        },
        complete: function () {
          anime({
            targets: titleRef.current,
            scale: [1, 1.05, 1],
            translateX: [0, -3, 3, -2, 2, 0],
            duration: 300,
            easing: 'easeOutExpo',
            complete: startTypewriter,
          });
        }
      });
    }
  }, []);

  const startTypewriter = () => {
    if (titleRef.current) {
      const originalHTML = titleRef.current.innerHTML;
      titleRef.current.innerHTML = '';
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = originalHTML;
      let charIndex = 0;
  
      const processNode = (node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          const text = node.textContent;
          text.split('').forEach((char, i) => {
            const span = document.createElement('span');
            span.textContent = char === ' ' ? '\u00A0' : char;
            span.style.opacity = '0';
            span.style.transform = 'scale(0.6) translateY(16px)';
            span.style.filter = 'blur(2px)';
            span.style.position = 'relative';
            span.style.display = 'inline-block';
            titleRef.current.appendChild(span);
  
            anime({
              targets: span,
              opacity: [0, 1],
              scale: [0.6, 1.25, 0.9, 1],
              translateY: [16, -20, 6, 0],
              filter: ['blur(2px)', 'blur(0px)'],
              duration: 750,
              delay: charIndex * 90,
              easing: 'easeOutElastic(1, 0.5)',
              update: function(anim) {
                const progress = anim.progress / 100;
                span.style.textShadow = `0 0 ${6 + 10 * progress}px #FA3633, 0 0 ${4 + 8 * progress}px #3A74E0`;
              },
              complete: function() {
                anime({
                  targets: span,
                  scale: [1, 1.1, 1],
                  duration: 100,
                  easing: 'easeOutExpo',
                });
                span.style.textShadow = '0 0 10px #FA3633, 0 0 5px #3A74E0';
                setTimeout(() => {
                  span.style.textShadow = '0 0 4px #FA3633';
                }, 120);
              }
            });
            charIndex++;
          });
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          if (node.tagName === 'BR') {
            titleRef.current.appendChild(node.cloneNode(true));
          } else {
            Array.from(node.childNodes).forEach(processNode);
          }
        }
      };
  
      Array.from(tempDiv.childNodes).forEach(processNode);
    }
  };

  const toggleMenu = (scrollObj) => {
    const scrollPos = Math.abs(scrollObj.translate);
    if (scrollPos >= 50 && isIn) {
      anime({
        targets: '.Main__Header__wrapper',
        opacity: 0,
        duration: 100,
        easing: 'linear',
      });
      const fixedContactDealy = document.querySelector('.fixed-contact-dealy');
      if (fixedContactDealy) {
        fixedContactDealy.style.display = 'flex';
      }
      anime({
        targets: '.fixed-contact-dealy',
        opacity: 1,
        duration: 100,
        easing: 'linear',
      });
      isIn = false;
    }

    if (scrollPos <= 49 && !isIn) {
      anime({
        targets: '.Main__Header__wrapper',
        opacity: 1,
        duration: 80,
        easing: 'linear',
      });
      anime({
        targets: '.fixed-contact-dealy',
        opacity: 0,
        duration: 80,
        easing: 'linear',
      });
      document.querySelector('.fixed-contact-dealy').style.display = 'none';
      isIn = true;
    }
  };

  const toggleMenuThrottle = throttle(toggleMenu, 100);

  return (
    <>
      <ParallaxLayer
        className="brand-service-slide-a"
        factor={layoutFactor}
        offset={pOffset + offsetAdjust}
        speed={0}
      >
        <div ref={ref}>
          <CylinderScroll onScreen={onScreen} />
        </div>
      </ParallaxLayer>
      <ParallaxLayer
        className="brand-service-slide-a-text"
        offset={pOffset + offsetAdjust}
        onFrame={toggleMenuThrottle}
        space={0}
        speed={0.5}
      >
        <div
          className="brand-service-slide-a-text-content"
          ref={titleRef}
        >
          LET'S MAKE<br />SOME NOIZ TOGETHER
        </div>
        <div
          className="brand-service-slide-a-text-subtitle"
          ref={subtitleRef}
        >
          <span className="subtitle-text">
            Bring noiz to your game full service influencer strategies
          </span>
        </div>

        <div ref={ref} />
      </ParallaxLayer>
      <ParallaxLayer
        className="scroll-for-more-brand"
        fontSize="large"
        offset={pOffset + offsetAdjust}
        space={0}
        speed={0.8}
      >
        <div className="scroll-notice-flex">
          <img src={scrollMouse} alt="scroll mouse" />
          <div>scroll for more</div>
        </div>
      </ParallaxLayer>
    </>
  );
};

export default AFullService;
